import { render, staticRenderFns } from "./carouselPage.vue?vue&type=template&id=2164672d&scoped=true&"
import script from "./carouselPage.vue?vue&type=script&lang=js&"
export * from "./carouselPage.vue?vue&type=script&lang=js&"
import style0 from "./carouselPage.vue?vue&type=style&index=0&id=2164672d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164672d",
  null
  
)

export default component.exports